module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "check-mark-2.77fe4838.svg";